module.exports = __webpack_public_path__ + "img/realtime.b092f3ed.png";